export const ErrorCode = {
  VALIDATION_ERROR: "VALIDATION_ERROR",
  PERMISSION_DENIED: "PERMISSION_DENIED",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  WORKFLOW_LOCKED: "WORKFLOW_LOCKED",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  TOKEN_REUSED: "TOKEN_REUSED",
  // Employees are mobile-only: the server refuses their web sign-in (and any
  // web session refresh) because a browser cannot produce device attestation.
  EMPLOYEE_APP_LOGIN_REQUIRED: "EMPLOYEE_APP_LOGIN_REQUIRED",
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

export interface ProblemError {
  code: string;
  title: string;
  detail: string;
  fieldErrors?: Record<string, string | string[]> | string[];
  traceId?: string;
}
